import { ref, watch } from '@vue/composition-api'

export default ({
  setup(props, context) {
    const { $store } = context.root
    const page = ref(null)
    const loading = ref(true)

    const fetchPage = async () => {
      const { slug } = context.root.$route.params
      loading.value = true
      page.value = await $store.dispatch('data/fetchPage', slug)
      loading.value = false
    }

    fetchPage()

    watch(() => context.root.$route, fetchPage)

    return {
      page,
      loading,
    }
  },
})
